module.exports = __webpack_public_path__ + "media/whats_your_status_series_your_college_application/Colleges_sidebar01-c79db487.gif";